import { Format } from './Format'

class TemplatePrintInfo {
  format
  colorPrint
  paperColor
  spinSide

  constructor (printInfo) {
    this.format = new Format(printInfo.format)
    this.colorPrint = printInfo.colorPrint
    this.paperColor = printInfo.paperColor
    this.spinSide = printInfo.spinSide
  }

  toObject () {
    return JSON.parse(JSON.stringify(this))
  }
}

// class ProjectPrintInfo {
//   isbn

//   constructor (props) {

//   }
// }

export { TemplatePrintInfo }
